import { LocalNotifications } from '@capacitor/local-notifications';

class Notifications {
  public async schedule(hour: number, minute: number, title: string, body: string) {
    try {
      // Request/ check permissions
    const state = await LocalNotifications.requestPermissions();
    if (state.display !== 'granted') return;
    
        console.log("Scheduling notification")
    await LocalNotifications.schedule({
        notifications: [
          {
            title: title,
            body: body,
            id: 1,
            schedule: {
                at: new Date(new Date().setHours(hour, minute, 0)),
                allowWhileIdle: true
            },
          },
        ],
      });
    } catch (error) {
      console.error(error);
    }
  }

  public async cancel() {
    try {
      const pending = await LocalNotifications.getPending();
      await LocalNotifications.cancel(pending);
    } catch (error) {
      console.error(error);
    }
  }
}

export default new Notifications()
